// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5246":"1f006d11","9166":"620c25d9"}[chunkId] || chunkId) + "." + {"3826":"69d7444e1ab32abc","5246":"927180eade7326e3","5646":"7fe365209efe4b9b","7655":"47ab8caf3c9a318c","9166":"c8cff952ba9ea8a0"}[chunkId] + ".js";
};